<template>
  <div class="addressContainer">
    <div v-if="list.length > 0" class="scroll">
      <!-- <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        style="overflow: auto; height: 100%"
      > -->
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="到底啦~"
        @load="onLoad"
      >
        <van-address-list
          v-model="chosenAddressId"
          :list="list"
          @add="onAdd"
          @edit="onEdit"
          :switchable="isSelecting"
          default-tag-text="默认"
          @select="onSelect"
        >
          <!-- <div slot="top" class="addressHeight">
              <van-cell
                :title="
                  defaultAddress.isDefault
                    ? '' + defaultAddress.name + ' ' + defaultAddress.tel
                    : isDefaultAddress
                "
                :label="defaultAddress.address"
                center
                clickable
              >
                <template slot="default">
                  <van-tag type="danger">默认地址</van-tag>
                </template>
              </van-cell>
            </div> -->
        </van-address-list>
      </van-list>
      <!-- </van-pull-refresh> -->
    </div>
    <div v-if="list.length == 0" class="addresslistEmpty">
      <van-cell
        v-if="!defaultAddress.isDefault"
        :title="isDefaultAddress"
        center
        clickable
        style="min-height: 60px"
        ><template slot="default">
          <van-tag type="danger">默认地址</van-tag>
        </template>
      </van-cell>
      <van-empty description="什么都没有哦" />
      <div class="bottomBackground">
        <van-button type="danger" class="bottomBtn" @click="onAdd"
          >新建收货地址</van-button
        >
      </div>
    </div>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {
  AddressList,
  ContactCard,
  Toast,
  Cell,
  Panel,
  Icon,
  Tag,
  List,
  PullRefresh,
  Button,
  Overlay
  // Empty
} from "vant";
import service from "../../api/user/address";
import loading from "../../components/loading/loading";
export default {
  components: {
    [AddressList.name]: AddressList,
    [ContactCard.name]: ContactCard,
    [Toast.name]: Toast,
    [Cell.name]: Cell,
    [Panel.name]: Panel,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Overlay.name]: Overlay,
    [Button.name]: Button,
    // [Empty.name]: Empty,
    loading
  },
  data() {
    return {
      isLoading: true, //loading状态
      urlName: "",
      chosenAddressId: "1",
      list: [],
      disabledlist: [],
      defaultAddress: {},
      isSelecting: true,
      isDefaultAddress: "请设置默认地址",
      type: 0,
      addressId: 0,
      goodsId: 0,
      quantity: 0,
      skuCode: 0,
      getParamsAddress: {},
      page: 1,
      pageSize: 8,
      loading: false,
      finished: false,
      refreshing: false
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.page = 1;
      this.addressList().then((addressList) => {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
        if (addressList.items.length !== 0) {
          this.list = addressList.items;
          let tData = [];
          let defaultData = [];
          addressList.items.map((v) => {
            tData.push({
              id: v.id,
              tel: v.cellPhone,
              name: v.name,
              address: v.province + v.city + v.district + v.details,
              isDefault: v.isDefault
            });

            if (v.isDefault) {
              defaultData = {
                id: v.id,
                tel: v.cellPhone,
                name: v.name,
                address: v.province + v.city + v.district + v.details,
                isDefault: v.isDefault
              };
            }
            if (addressList.totalCount < 8) {
              this.finished = true;
            }
          });
          this.list = tData;
          this.defaultAddress = defaultData;
        } else {
          this.list = [];
          this.defaultAddress.isDefault = false;
        }
        this.loading = false;
        if (addressList.totalCount <= 8) {
          this.finished = true;
        }
      });
    },
    onLoad() {
      this.page++;
      this.addressList().then((addressList) => {
        if (addressList.items.length !== 0) {
          // this.list = addressList.items;
          let tData = [];
          let defaultData = [];
          addressList.items.map((v) => {
            tData.push({
              id: v.id,
              tel: v.cellPhone,
              name: v.name,
              address: v.province + v.city + v.district + v.details,
              isDefault: v.isDefault
            });

            if (v.isDefault) {
              defaultData = {
                id: v.id,
                tel: v.cellPhone,
                name: v.name,
                address: v.province + v.city + v.district + v.details,
                isDefault: v.isDefault
              };
            }
          });
          this.list = this.list.concat(tData);
          this.defaultAddress = defaultData;
        } else {
          this.list = [];
          this.defaultAddress.isDefault = false;
        }
        this.loading = false;
        if (addressList.totalCount <= this.list.length) {
          this.finished = true;
        }
      });
    },
    // onRefresh() {
    //   // 清空列表数据
    //   this.page = 1;
    //   this.finished = false;
    //   // 重新加载数据
    //   // 将 loading 设置为 true，表示处于加载状态
    //   this.loading = true;
    //   this.list = [];
    //   this.isLoading = true;
    //   this.addressList().then((addressList) => {
    //     setTimeout(() => {
    //       this.isLoading = false;
    //     }, 500);
    //     if (addressList.items.length !== 0) {
    //       this.list = addressList.items;
    //       let tData = [];
    //       let defaultData = [];
    //       addressList.map((v) => {
    //         tData.push({
    //           id: v.id,
    //           tel: v.cellPhone,
    //           name: v.name,
    //           address: v.province + v.city + v.district + v.details,
    //           isDefault: v.isDefault
    //         });

    //         if (v.isDefault) {
    //           defaultData = {
    //             id: v.id,
    //             tel: v.cellPhone,
    //             name: v.name,
    //             address: v.province + v.city + v.district + v.details,
    //             isDefault: v.isDefault
    //           };
    //         }
    //       });
    //       this.list = tData;
    //       this.defaultAddress = defaultData;
    //     } else {
    //       this.list = [];
    //       this.defaultAddress.isDefault = false;
    //     }
    //     if (addressList.totalCount <= this.list.length) {
    //       this.finished = true;
    //       this.loading = false;
    //     }
    //     //
    //     // this.refreshing = true;
    //     // this.onLoad();
    //   });
    // },
    addressList() {
      return new Promise((resolve, reject) => {
        service
          .getAddress(this.page, this.pageSize)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject();
          });
      });
    },
    onAdd() {
      this.$router.push({
        name: "addressedit",
        query: { id: 0, type: "add" }
      });
    },
    onSelect(item, index) {
      if (this.urlName == "package") {
        this.$router.replace({
          name: "package",
          query: {
            addressId: item.id,
            packageId: this.packageId
          }
        });
      } else {
        let getParamsAddress = {
          addressId: "",
          address: {}
        };
        getParamsAddress.addressId = item.id;
        getParamsAddress.address = item;
        localStorage.setItem(
          "getParamsAddress",
          JSON.stringify(getParamsAddress)
        );
        this.$router.go(-1);
      }
    },
    onEdit(item) {
      this.$router.push({
        name: "addressedit",
        query: { id: item.id, type: "update" }
      });
    }
  }
};
</script>
<style lang="less" scoped>
@deep: ~">>>";
.addressContainer {
  min-height: 100vh;
  .van-address-list__bottom {
    background-color: #f8f8f8;
    padding-bottom: 6vw;
  }
}

.addressHeight {
  @{deep} .van-cell--center {
    padding: 4.66667vw 4.26667vw;
    justify-content: space-between;
  }
  .van-cell__title,
  .van-cell__value {
    flex: inherit;
  }
}
.scroll {
  height: 100%;
  padding-bottom: 19.4vw;
  overflow-y: scroll;
}

.van-list {
  // padding-bottom: 17vw;
  margin-top: 0;
  width: 100%;
  overflow-y: scroll;
  background: #f8f8f8;
}
.van-address-item:not(:last-child) {
  margin-bottom: 0;
}
.van-address-item__name {
  font-size: 14px;
}
.van-address-item__address {
  font-size: 12px;
  color: #a8a8a8;
}
.van-tag--round {
  border-radius: 2px;
}
@{deep}.van-address-list {
  padding: 0;
  .van-radio-group {
    border-top: 1px solid #f7f7f7;
  }
  .van-address-item {
    border-radius: 0;
    padding: 3.2vw 1vw 3.2vw 2.2vw;
    border-bottom: 1px solid #f7f7f7;
  }
  .van-button--round {
    border-radius: 2vw;
  }
}
</style>